import { useState } from "react";
import DashboardMobileDrawer from "./mobile-drawer";
import DashboardNavbar from "./navbar";

export const NAVIGATION = {
  pages: [
    { name: "Get a Quote", href: "/dashboard/get-a-quote" },
    { name: "Orders", href: "/dashboard/orders" },
  ],
};

export default function NavDashboard() {
  const [open, setOpen] = useState(false);

  return (
    <div className="lg:hidden sticky top-0 z-40">
      <DashboardMobileDrawer open={open} setOpen={setOpen} />

      <DashboardNavbar navigation={NAVIGATION} setOpen={setOpen} />
    </div>
  );
}
